export * from './lib/icons.module';
export * from './lib/icons.service';
export * from './lib/registry';
